import { FC } from 'react';
import { RouterProvider } from 'react-router-dom';
import { browserRouter } from '../model/RouterProvider';

export const BrowserRouter:FC = () => (
  <RouterProvider router={browserRouter} />
);
